module.exports = __webpack_public_path__ + "static/all-forms-7469640540070431f6af9a0c3300e5fa.pdf";